import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "d-flex flex-wrap menu-wrapper" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 2,
  class: "menu-title"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_badge = _resolveComponent("v-badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMenus, (m) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "menu d-flex flex-column align-center pa-3 mt-4",
          key: m.type,
          onClick: ($event: any) => (_ctx.clickMenu(m))
        }, [
          (m.type === 'invoice')
            ? (_openBlock(), _createBlock(_component_v_badge, {
                key: 0,
                "model-value": _ctx.noneRead,
                color: "red",
                "offset-x": "30",
                "offset-y": "8",
                overlap: "",
                small: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    class: "mb-2",
                    width: "120",
                    height: "120",
                    src: m.img ?? undefined,
                    contain: ""
                  }, null, 8, ["src"])
                ]),
                _: 2
              }, 1032, ["model-value"]))
            : (_openBlock(), _createBlock(_component_v_img, {
                key: 1,
                class: "mb-2",
                width: "120",
                height: "140",
                src: m.img ?? undefined,
                contain: ""
              }, null, 8, ["src"])),
          (m.locale !== 'ja')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(m.title), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_3))
      }), 128))
    ])
  ]))
}